/** Parses currency-like form/API values (commas, spaces) into a finite number. */
export function parsePropertyFinanceAmount(value: unknown): number {
  const raw = String(value ?? '')
    .trim()
    .replace(/[₹,\s]/g, '');
  if (!raw) {
    return 0;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : 0;
}

/** Property amount = Agreement Value + GST. */
export function resolvePropertyAmountWithGst(
  agreementAmount: unknown,
  gstAmount: unknown,
): number {
  return (
    parsePropertyFinanceAmount(agreementAmount) +
    parsePropertyFinanceAmount(gstAmount)
  );
}

/** Loan amount derived from property amount minus owner contribution. */
export function calculateLoanAmountFromOwnContribution(
  propertyAmount: number,
  ownContribution: number,
): number {
  const property = Number.isFinite(propertyAmount) ? propertyAmount : 0;
  const own = Number.isFinite(ownContribution) ? ownContribution : 0;
  return Math.max(0, property - own);
}
